import { Link } from '@tanstack/react-router'
import { ArrowRight, Sparkles, Smartphone } from 'lucide-react'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { buttonVariants } from '@/components/ui/Button'

export function ProductTeaserSection() {
  return (
    <Section surface="0" withBorder>
      <Container>
        <div className="relative overflow-hidden rounded-sm border border-border bg-surface-2 p-5 sm:p-10 md:p-14">
          {/* Subtle architectural apex watermark */}
          <div
            className="pointer-events-none absolute -right-12 -top-12 opacity-[0.03] dark:opacity-[0.05] select-none hidden sm:block"
            aria-hidden="true"
          >
            <Sparkles size={320} />
          </div>

          <div className="relative z-10 max-w-2xl">
            <div className="flex flex-wrap items-center gap-2 mb-3 sm:mb-4">
              <span className="font-mono text-xs font-semibold px-2.5 py-1 rounded-xs bg-surface-3 text-fg border border-border-subtle flex items-center gap-1.5">
                <Smartphone size={13} />
                // UPCOMING NATIVE APP: SUKE (ሱቄ)
              </span>
              <span className="flex items-center gap-1.5 text-xs text-fg-muted font-medium">
                <span className="h-1.5 w-1.5 rounded-full bg-success inline-block animate-pulse" />
                Active Engineering
              </span>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-fg text-balance">
              SUKE: Pocket Retail & POS Management.
            </h2>

            <p className="mt-3 sm:mt-4 text-sm sm:text-base text-fg-subtle leading-relaxed">
              We are developing SUKE to empower local boutiques, apparel shops, and neighborhood mini-marts across Ethiopia. It converts any mobile phone into an autonomous POS terminal with instant Telebirr checkout, automated stock ledgers, and 100% offline resilience.
            </p>

            <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Link
                to="/contact"
                className={buttonVariants({ variant: 'primary', size: 'md' })}
              >
                <span>Inquire About SUKE</span>
                <ArrowRight size={15} />
              </Link>

              <Link
                to="/products"
                className={buttonVariants({ variant: 'outline', size: 'md' })}
              >
                <span>View All Products</span>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  )
}
